import { Label } from '../../../label/models/label.model';

export const EXAMPLE_LABELS: Pick<Label, 'id' | 'color' | 'displayName' | 'subCategory'>[] = [
  {
    id: 'label-prio-important',
    color: '#ff0000',
    displayName: 'Important',
    subCategory: 'Prio',
  },
  {
    id: 'label-investor-contoso',
    color: '#6699cc',
    displayName: 'Contoso',
    subCategory: 'Investor',
  },
];
